import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { BannerDetailsContainerComponent } from "./bannerDetails-container.component";
import { BannerDetailsComponent } from "./components/bannerDetails.component";

@NgModule({
    declarations: [
        BannerDetailsContainerComponent,
        BannerDetailsComponent
    ],
    imports: [
      SharedModule,
    ],
    providers: [
      {
        provide: 'components',
        useValue: [BannerDetailsContainerComponent, BannerDetailsComponent],
        multi: true
      }
    ],
    entryComponents: [
        BannerDetailsContainerComponent
    ],
  })
  export class BannerDetailsModule { }